// Browsers name every clipboard image "image.png", so numbered names keep
// several pasted files apart in an uploads list.
const CLIPBOARD_IMAGE_NAME = /^image\.[a-z0-9]+$/i;
const PLAIN_EXTENSION = /^[a-z0-9]+$/i;
const FALLBACK_EXTENSION = 'png';

// Mime subtypes aren't always usable as an extension, e.g. "svg+xml".
function extensionFromType(type: string): string {
  const subtype = type.split('/').pop()?.split('+')[0] ?? '';
  return PLAIN_EXTENSION.test(subtype) ? subtype : FALLBACK_EXTENSION;
}

export default function namePastedFile(file: File, index: number): File {
  if (!file.type.startsWith('image/')) return file;
  if (file.name && !CLIPBOARD_IMAGE_NAME.test(file.name)) return file;
  const named = file.name.split('.').pop();
  const extension =
    named && PLAIN_EXTENSION.test(named) ? named : extensionFromType(file.type);
  return new File([file], `pasted-image-${index}.${extension}`, {
    type: file.type,
  });
}
